import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/hooks/useAuthStore';

// /dashboard is an ADMIN/PROPERTY_MANAGER/AGENT/SUPER_ADMIN page. OWNER and
// LANDLORD have their own home at /owner-portal — this guard keeps them off
// /dashboard even via a direct/bookmarked URL, matching RootRedirect's role
// logic for the "/" landing route.
const DashboardGuard = () => {
  const role = useAuthStore((state) => state.user?.role);

  if (role === 'OWNER' || role === 'LANDLORD') {
    return <Navigate to="/owner-portal" replace />;
  }
  if (role === 'AMBASSADOR') {
    return <Navigate to="/ambassador" replace />;
  }

  return <Outlet />;
};

export default DashboardGuard;
